import qs from 'query-string'

export function getCategorySlugFromPath(match) {
  return (
    match.params.subCategory2 ||
    match.params.subCategory1 ||
    match.params.category ||
    'products'
  )
}

export function trimSlashes(url) {
  const matches = url.match(/^\/(\S+[^/])\/?$/)
  return matches.length > 1 ? matches[1] : url
}

export function getFilterStateFromPath({ location }) {
  const queryParams = qs.parse(location.search)
  const page = Math.max(0, (queryParams.page || 1) - 1)
  delete queryParams.page
  const onSale = queryParams.on_sale === 'true'
  delete queryParams.on_sale

  const filterState = {
    onSale,
    page,
    ...queryParams,
  }
  if (queryParams.retailer) {
    filterState.store = queryParams.retailer
  }
  if (queryParams.search_query) {
    filterState.searchQuery = queryParams.search_query
  }
  if (queryParams.colour) {
    filterState.color = queryParams.colour
  }
  return filterState
}

export function buildUrlFromFilterState(filterState) {
  const params = {}
  const queryParams = [
    'brand',
    'page',
    'sort',
    'minPrice',
    'maxPrice',
    'search_query',
  ]

  // resolve naming diff's
  params['retailer'] = filterState['store']
  params['on_sale'] = filterState['onSale']
  params['colour'] = filterState['color']

  queryParams.forEach(param => (params[param] = filterState[param]))
  // Update the page param if it exists
  if (params.page !== undefined) {
    params.page++
    if (params.page === 1) {
      delete params.page
    }
  }
  // Remove the onSale param if it's set to false
  if (!params.on_sale) {
    delete params.on_sale
  }

  const prefix =
    filterState.categoryPath === 'products'
      ? filterState.prefix || 'products'
      : filterState.categoryPath

  const paramsOrder = ['colour', 'retailer', 'brand', 'on_sale', 'page']
  const search = qs.stringify(params, {
    sort: (m, n) => paramsOrder.indexOf(m) >= paramsOrder.indexOf(n),
  })
  return `/${prefix}?${search}`
}
